import loadable from "react-loadable";
import LoadingContent, {
    LoadingLoggedIn,
    LoadingPublic,
} from "../views/LoadingContent/LoadingContent";
import {retryChunkLoad} from "../helpers/retryChunkLoad";

export const Attendees = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "attendees", webpackPrefetch: true */ "./customers/Customers"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Courses = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "courses", webpackPrefetch: true */ "./courses/Courses"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Locations = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "locations", webpackPrefetch: true */ "./locations/Locations"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Bookings = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "bookings", webpackPrefetch: true */ "./bookings/Bookings"
                )
        ),
    loading: LoadingLoggedIn,
});

export const MyBookings = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "myBookings", webpackPrefetch: true */ "./myBookings/MyBookings"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Staff = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "staff", webpackPrefetch: true */ "./staff/Staff"
                )
        ),
    loading: LoadingLoggedIn,
});

export const StaffLogin = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "staff", webpackPrefetch: true */ "./staffLogin/StaffLogin"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Settings = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "staff", webpackPrefetch: true */ "./settings/Settings"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Login = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "staff", webpackPrefetch: true */ "./login/Login"
                )
        ),
    loading: LoadingPublic,
});

export const Setup = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "setup", webpackPrefetch: true */ "./setup/Setup"
                )
        ),
    loading: LoadingPublic,
});

export const NotFound = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "not-found", webpackPrefetch: true */ "./common/NotFound"
                )
        ),
    loading: LoadingPublic,
});

export const TopLevelPage = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "top-level-page", webpackPrefetch: true */ "./topLevelPage/TopLevelPage"
                )
        ),
    loading: LoadingPublic,
});

export const TopLevelPageMobile = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "top-level-page", webpackPrefetch: true */ "./topLevelPageMobile/TopLevelPageMobile"
                )
        ),
    loading: LoadingPublic,
});

export const WelcomePage = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "top-level-page", webpackPrefetch: true */ "./welcomePage/WelcomePage"
                )
        ),
    loading: LoadingPublic,
});

export const Invoice = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "invoice", webpackPrefetch: true */ "./invoice/Invoice"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Templates = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "templates", webpackPrefetch: true */ "./templates/Templates"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Payments = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "payments", webpackPrefetch: true */ "./payments/Payments"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Withdrawals = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "withdrawals", webpackPrefetch: true */ "./withdrawal/Withdrawals"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Newsletter = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "newsletter" */ "./newsletter/Newsletter"
                )
        ),
    loading: LoadingLoggedIn,
});

export const InterestLists = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "interestLists", webpackPrefetch: true */ "./interestLists/InterestLists"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Notifications = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "payments", webpackPrefetch: true */ "./notifications/Notifications"
                )
        ),
    loading: LoadingLoggedIn,
});

export const Account = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "payments", webpackPrefetch: true */ "./account/Account"
                )
        ),
    loading: LoadingPublic,
});

export const ChangeLog = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "payments", webpackPrefetch: true */ "./changelog/ChangeLog"
                )
        ),
    loading: LoadingPublic,
});

export const Help = loadable({
    loader: () => retryChunkLoad(() => import(/* webpackChunkName: "help", webpackPrefetch: true */ "./help/Help")),
    loading: LoadingPublic,
});

export const Badges = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "badges", webpackPrefetch: true */ "./badges/Badges"
                )
        ),
    loading: LoadingPublic,
});

export const Certificates = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "certificates", webpackPrefetch: true */ "./certificates/Certificates"
                )
        ),
    loading: LoadingPublic,
});

export const PermissionDenied = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "payments", webpackPrefetch: true */ "./permissions/Permissions"
                )
        ),
    loading: LoadingPublic,
});

export const InstructorRouter = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "instructorRouter", webpackPrefetch: true */ "./instructorRouter/InstructorRouter"
                )
        ),
    loading: LoadingPublic,
});

export const LessonsToday = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "lessonsToday", webpackPrefetch: true */ "./lessonsToday/LessonsToday"
                )
        ),
    loading: LoadingPublic,
});

export const AreaManager = loadable({
    loader: () =>
        retryChunkLoad(
            () =>
                import(
                    /* webpackChunkName: "areaManager", webpackPrefetch: true */ "./areaManager/AreaManager"
                )
        ),
    loading: LoadingLoggedIn,
});
